import { BrowserRouter as Router } from "react-router-dom";
import PageBackground from "./components/PageBackground";
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import Proof from "./components/Proof";
import Process from "./components/Process";
import Services from "./components/Services";
import Skills from "./components/Skills";
import { Contact } from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <PageBackground />
      <NavBar />
      <Hero />
      <main className="relative">
        <Proof />
        <Process />
        <Services />
        <Skills />
        <Contact />
      </main>
      <Footer />
    </Router>
  );
}

export default App;
